import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { equal } from '@ember/object/computed';
import { SqlImportDatabase } from 'cio/utils/sql-import';

export default class SqlImportDatabaseModel extends Model {
  @attr('string') type!: SqlImportDatabase;
  @attr('string') name!: string;
  @attr('string') role!: string;
  @attr('string') username!: string;
  @attr('string') password!: string;
  @attr('string') host!: string;
  @attr('string') warehouse!: string;
  @attr('number') port!: number;
  @attr('boolean') ssl!: boolean;
  @attr('boolean') inUse!: boolean;
  @attr('string') projectId!: string;
  @attr('string') sslServerCA!: string;
  @attr('string') sslClientKey!: string;
  @attr('string') sslClientCert!: string;
  @equal('type', SqlImportDatabase.snowflake) isSnowflake!: boolean;
  @equal('type', SqlImportDatabase.mysql) isMySQL!: boolean;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'sql-import-database': SqlImportDatabaseModel;
  }
}
